import { variables } from '@styles';
import { content } from '@content';

import { PERSONALIZATION_TOKEN_TAG } from '@utils/personalization';

/**
 SampleTemplate component variables
 @returns {variables}
 */

export const SPLITTER_DATASET_ID_KEY = 'sampleTemplateSplitter';

export const SPLITTER_DATASET_EXPERIENCE_ID_KEY = 'sampleTemplateJourney';

export const SPLITTER_DATASET_DISCLOSURE = 'sampleTemplateDisclosure';

export const GLOBAL_STYLES_ID = 'sampleTemplateGlobalStyles';

export const SPLITTER_ACTIVE_CLASSNAME = 'drag-enter';

export const SPLITTER_DROPPED_CLASSNAME = 'drag-dropped';

export const SPLITTER_FILLED_CLASSNAME = 'filled';

export const DATA_SPLITTER_ATTRIBUTE = 'data-sample-template-splitter';

export const DATA_FILLED_ATTRIBUTE = 'data-sample-template-journey';

export const DATA_DISCLOSURE_ATTRIBUTE = 'data-sample-template-disclosure';

export const DATA_DISCLOSURE_CONTENT_ATTRIBUTE = 'data-sample-template-disclosure-content';

export const DATA_EXPERIENCE_ID = 'data-experience-id';

export const DATA_FOOTER_ATTRIBUTE = 'data-template-footer';

export const TRASH_CAN_WIDTH = 26; // padding 5px left 5px right + 16px width

export const DELETE_MODULE_ICON_ID = 'delete-module-trash-icon';

export const EMPTY_MODULE_NOTE = `
  <div class="empty-module-note">
    <div class="empty-module-content">
      <svg
        width="24"
        height="24"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 8C14 4.6875 11.3125 2 8 2C4.6875 2 2 4.6875 2 8C2 11.3125 4.6875 14 8 14C11.3125 14 14 11.3125 14 8Z"
          stroke="${variables.colorV2.module.border.active}"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M10.5 8H5.5M8 5.5V10.5V5.5Z"
          stroke="${variables.colorV2.module.border.active}"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <p class="empty-module-title">${content.addContentHere}</p>
    </div>
  </div>
`;

export const DISCLOSURE_TITLE_CLASSNAME = 'disclosure-title';

export const DISCLOSURE_TITLE_STYLES = `
  margin: 0;
  padding: 16px 0 12px;
  font-family: 'Manrope', sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 13px;
  color: ${variables.color.primary.black};
  border-bottom: solid 1px ${variables.color.primary.halfMediumGray};
`;

export const IFRAME_STYLES = `
  ${PERSONALIZATION_TOKEN_TAG} {
    background-color: ${variables.colorV2.personalizationToken.background};
    border-radius: 3rem;
    color: ${variables.colorV2.personalizationToken.text};
    padding: 0 10px;
    pointer-events: none;
  }
  *[${DATA_SPLITTER_ATTRIBUTE}] {
    background-color: transparent;
    min-height: 10px;
    position: relative;
    overflow: hidden;
  }
  *[${DATA_SPLITTER_ATTRIBUTE}]:before {
    content: '';
    position: absolute;
    height: 0.5px;
    width: 100%;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    transition: background-color 0.4s;
    background-color: transparent;
  }
  @keyframes splitterHeightAnimation {
    0% {
      height: 10px;
    }
    66.67% {
      height: 10px;
    }
    100% {
      height: 100px;
    }
  }
  .${SPLITTER_ACTIVE_CLASSNAME}:not(.${SPLITTER_FILLED_CLASSNAME})[${DATA_SPLITTER_ATTRIBUTE}] {
    animation: splitterHeightAnimation 1.5s ease-in-out forwards;
    /* background-color: rgba(2, 80, 217, .2); */
    background-color: transpaent;
    border: thin dashed ${variables.colorV2.contentModule.border.default};
    border-radius: 0.6rem;
   }

  .${SPLITTER_ACTIVE_CLASSNAME}:not(.${SPLITTER_FILLED_CLASSNAME})[${DATA_SPLITTER_ATTRIBUTE}]:before {
    background-color:rgba(2, 80, 217, .2);
    color: #89939c;
    content: '${content.dropModuleHere}';
    font-size: 13px;
    font-weight: 600;
    height: 100%;
    line-height: 100px;
    transition: background-color 0.4s;
  }
  .${SPLITTER_DROPPED_CLASSNAME}:not(.${SPLITTER_FILLED_CLASSNAME})[${DATA_SPLITTER_ATTRIBUTE}]:before {
    content: '${content.addingModule}';
  }
  .${SPLITTER_FILLED_CLASSNAME}[${DATA_SPLITTER_ATTRIBUTE}] {
    cursor: grab;
    overflow: hidden;
  }
  *[${DATA_SPLITTER_ATTRIBUTE}] * {
    pointer-events: none;
    user-select: none;
  }
  .empty-module-note {
    padding: 50px 15px;
    text-align: center;
  }
  .empty-module-content {
    display: flex;
    justify-content: center;
    gap: 10px;
  }
  .empty-module-note p {
    margin: 0; 
  }
  .empty-module-note svg {
    margin-bottom: 5px; 
  }
  .empty-module-title {
    margin-bottom: 5px;
    font-family: 'Manrope', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 25px;
    color: ${variables.colorV2.text.header};
  }
  .loader-wrapper {
    height: 54px;
    display: flex;
  }
  .loader {
    margin: auto;
    width: 20px;
    height: 20px;
    animation: spin 2s linear infinite;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .disclosure-title {${DISCLOSURE_TITLE_STYLES}}
`;

export const ELEM_INFO_SVG = `<svg width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.3425 4.68156L7.34985 4.6875C7.426 4.75093 7.47705 4.8394 7.49395 4.93705C7.5108 5.0347 7.49235 5.1352 7.4419 5.22045L6.77455 6.375L6.7725 6.37845C6.72205 6.4627 6.6436 6.5266 6.55085 6.559C6.4581 6.59135 6.35695 6.5902 6.265 6.5556L6.25955 6.55345L5.6794 6.31985C5.6429 6.3051 5.60345 6.2992 5.56425 6.30265C5.52505 6.3061 5.48725 6.3188 5.4539 6.3397C5.4033 6.3714 5.3511 6.40185 5.29765 6.4306C5.26345 6.4493 5.23405 6.47575 5.21185 6.5078C5.18965 6.5399 5.17525 6.5767 5.16985 6.6153L5.0828 7.23515L5.0814 7.2439C5.06475 7.34155 5.01415 7.43015 4.93855 7.49415C4.86295 7.55815 4.76719 7.59345 4.66814 7.59375H3.33189C3.23405 7.59295 3.13947 7.55845 3.0641 7.4961C2.98874 7.4337 2.93718 7.3472 2.91814 7.25125L2.91626 7.24L2.82939 6.6214C2.82402 6.58275 2.80964 6.5459 2.78741 6.5138C2.76518 6.48175 2.73573 6.4553 2.70142 6.4367C2.6485 6.40805 2.59642 6.37755 2.54517 6.34515C2.51177 6.3241 2.47386 6.31135 2.43455 6.3078C2.39524 6.3043 2.35566 6.3102 2.31907 6.325L1.73985 6.5583L1.73439 6.5603C1.64256 6.59475 1.54157 6.59595 1.44894 6.5637C1.35632 6.53145 1.27792 6.4678 1.22735 6.38375L1.22532 6.3803L0.557976 5.22565C0.507681 5.1404 0.489339 5.0401 0.506231 4.94258C0.523116 4.84509 0.574136 4.75677 0.650166 4.69344L0.657511 4.6875L1.15048 4.30062C1.1816 4.27621 1.20648 4.24475 1.22308 4.20884C1.23967 4.17292 1.24751 4.13359 1.24595 4.09406V3.91344C1.24767 3.87366 1.23992 3.83404 1.22335 3.79783C1.20679 3.76162 1.18186 3.72986 1.15064 3.70515L0.657511 3.31844L0.650166 3.3125C0.574061 3.24908 0.523001 3.16066 0.506111 3.06305C0.489222 2.96543 0.507606 2.86499 0.557976 2.77969L1.22626 1.62422L1.22829 1.62078C1.2788 1.53655 1.35724 1.47269 1.44997 1.44032C1.54269 1.40795 1.64383 1.40911 1.73579 1.4436L1.74126 1.44578L2.32142 1.68016C2.35789 1.69492 2.39734 1.70082 2.43654 1.69737C2.47573 1.69392 2.51355 1.68122 2.54689 1.66032C2.59795 1.62829 2.65007 1.59796 2.70314 1.56938C2.73722 1.5506 2.76646 1.52413 2.78851 1.49206C2.81056 1.46 2.82483 1.42324 2.83017 1.38469L2.9172 0.764845L2.9186 0.756095C2.93527 0.658455 2.98586 0.569825 3.06147 0.50583C3.13707 0.44183 3.23283 0.406567 3.33189 0.40625H4.66814C4.76581 0.407252 4.86017 0.441846 4.93534 0.50422C5.0105 0.56659 5.06195 0.652935 5.08095 0.74875L5.0828 0.76L5.17015 1.37859C5.17555 1.41725 5.1899 1.4541 5.21215 1.48619C5.23435 1.51827 5.2638 1.54467 5.29815 1.56328C5.35105 1.59203 5.40315 1.62255 5.4544 1.65484C5.4878 1.67587 5.5257 1.68867 5.565 1.69218C5.6043 1.69568 5.6439 1.68979 5.6805 1.675L6.26015 1.44172L6.26565 1.43968C6.35745 1.40523 6.45845 1.40403 6.5511 1.43629C6.6437 1.46854 6.7221 1.53221 6.77265 1.61625L6.7747 1.61969L7.44205 2.77437C7.49235 2.85959 7.5107 2.95992 7.4938 3.05742C7.4769 3.15492 7.4259 3.24323 7.34985 3.30656L7.3425 3.3125L6.84955 3.69937C6.8184 3.72379 6.79355 3.75526 6.77695 3.79117C6.76035 3.82708 6.7525 3.86641 6.75405 3.90594V4.08657C6.75235 4.12635 6.7601 4.16597 6.77665 4.20217C6.79325 4.23838 6.81815 4.27014 6.8494 4.29485L7.3425 4.68156ZM5.0142 4.7307C5.1558 4.53416 5.2372 4.30071 5.2486 4.05875C5.25625 3.88504 5.2277 3.71163 5.16475 3.54956C5.10175 3.38748 5.00575 3.24029 4.8828 3.11733C4.75985 2.99436 4.61267 2.89833 4.4506 2.83534C4.28853 2.77234 4.11513 2.74376 3.94142 2.75141C3.69945 2.76275 3.46599 2.84416 3.26944 2.98573C3.07288 3.12731 2.92169 3.32294 2.83426 3.54884C2.74682 3.77474 2.72691 4.02118 2.77693 4.25819C2.82696 4.4952 2.94477 4.71257 3.11605 4.88386C3.28732 5.05515 3.50468 5.173 3.74168 5.22305C3.97869 5.2731 4.22513 5.2532 4.45104 5.1658C4.67695 5.0784 4.8726 4.92724 5.0142 4.7307Z"
      fill="white"
    />
  </svg>`;

export const TRASH_SVG = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 4L4.55556 13.0909C4.58194 13.6162 4.95556 14 5.44444 14H10.5556C11.0464 14 11.4131 13.6162 11.4444 13.0909L12 4"
      stroke="#fff"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 4H13H3Z"
      fill="#fff"
    />
    <path
      d="M3 4H13"
      stroke="#fff"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M6 2L10 2"
      stroke="#fff"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`;

export const DOC_REDEFINE_DELAY = 200;

export const DEFAULT_WRAPPED_ELEM_STYLES =
  'cursor: pointer; \nborder: .2rem solid transparent; \nborder-radius: 2px; \nborder-width: .2rem 0 !important; \nposition: relative; \nmargin-bottom: 0; \nmargin-top: 0; \nborder-color: transparent;';

// Top Offsets for modal
export const MODULE_MODAL_Y_OFFSET_CORREC_NUM = 180; // 200;

export const MODULE_MODAL_Y_TEMPLATE_EDITOR_OFFSET = 15;

export const MODULE_MODAL_Y_DEPLOYMENT_HEADER_OFFSET = 42;

export const MODULE_REF_INIT = {
  html: '',
  dirty: false,
  getClearModuleHtml: () => ({ moduleHtml: '', filledAttrValue: '' }),
};

export const TEMPLATE_FOOTER = `
<div ${DATA_FOOTER_ATTRIBUTE}>
  <table style="margin: auto" class="container" cellpadding="0" cellspacing="0" width="600">
    <tr>
      <td align="center" valign="top" style="background: #fff" width="100%">
        <table class="container" cellpadding="0" cellspacing="0" width="600">
          <tr>
            <td
              align="center"
              style="
            font-family: Verdana, Helvetica, Arial, sans-serif;
            font-size: 11px;
            color: #959595;
            padding: 0 0 25px 0;
          "
            >
              This email was sent by:
              <span>
                %%Member_Busname%%
                <br />
                %%Member_Addr%%, %%Member_City%%, %%Member_State%%, %%Member_PostalCode%% %%Member_Country%%
              </span>
              <br />
              <br />
              <a
                href="http://www.exacttarget.com/privacy-policy"
                alias="Privacy   Policy"
                target="_blank"
                style="
              font-size: 12px;
              color: #959595;
              text-decoration: none;
              font-weight: bold;
            "
              >
                Privacy Policy
              </a>
              <br />
              <br />
              <a
                href="%%profile_center_url%%"
                alias="Update   Profile"
                target="_blank"
                style="
              font-size: 12px;
              color: #959595;
              text-decoration: none;
              font-weight: bold;
            "
              >
                Update Profile
              </a>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <a
                href="%%subscription_center_url%%"
                alias="Manage   Subscriptions"
                target="_blank"
                style="
              font-size: 12px;
              color: #959595;
              text-decoration: none;
              font-weight: bold;
            "
              >
                Manage Subscriptions
              </a>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <a
                href="%%unsub_center_url%%"
                alias="Unsubscribe"
                target="_blank"
                style="
              font-size: 12px;
              color: #959595;
              text-decoration: none;
              font-weight: bold;
            "
              >
                Unsubscribe
              </a>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</div>`;

export const SPLITTER_LOADER_HTML = `
<div class="module-loader">
  <div class="module-loader-group">
    <div class="module-loader-list">
      <div class="module-loader-image">
        <span class="loader-element"></span>
      </div>
      <div class="module-loader-meta">
        <div class="module-loader-intro">
          <span class="loader-element"></span>
          <span class="loader-element"></span>
          <span class="loader-element"></span>
          <span class="loader-element"></span>
          <span class="loader-element"></span>
          <span class="loader-element"></span>
        </div>
      </div>
    </div>
  </div>
</div>`;

export const SPLITTER_LOADER_STYLES_ID = 'splitter_loader_styles';

export const SPLITTER_LOADER_STYLES = `
[${DATA_SPLITTER_ATTRIBUTE}]:has(.module-loader) {
  pointer-events: none;
}
.module-loader .module-loader-group {
  display: flex;
  align-items: center;
  justify-content: center;
}

.module-loader .module-loader-group .module-loader-list {
  display: flex;
  flex-direction: column;
  width: 263px;
  height: auto;
  margin: 20px 15px;
}

.module-loader .module-loader-group .module-loader-list .module-loader-image {
  position: relative;
  width: 100%;
  height: 160px;
  display: block;
  margin-bottom: 15px;
  overflow: hidden;
  background: #eee;
  border-radius: 5px;
}

.module-loader .module-loader-group .module-loader-meta .module-loader-intro {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.module-loader
  .module-loader-group
  .module-loader-meta
  .module-loader-intro
  span {
  border-radius: 3px;
  height: 20px;
  margin-bottom: 8px;
}

.module-loader
  .module-loader-group
  .module-loader-meta
  .intro
  span:first-child {
  background: red;
  margin-right: 15px;
}

.module-loader .module-loader-group .module-loader-meta .module-loader-title {
  height: 30px;
  margin: auto 0 10px 0;
}

.module-loader .loader-element {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  background: #dadada;
  overflow: hidden;
}

.module-loader .loader-element:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(#dadada, #f2f2f2, #dadada);
  transform: rotate(120deg);
  animation: loading 2s infinite;
}

@keyframes loading {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

@media (min-width: 600px) {
  .module-loader .module-loader-meta {
    margin: auto 0;
  }
  .module-loader .module-loader-group .module-loader-list {
    flex-direction: row;
    width: 100%;
    height: auto;
    margin: 20px 15px;
  }

  .module-loader .module-loader-group .module-loader-list .module-loader-image {
    margin-bottom: 0;
    margin-right: 30px;
    width: 300px;
  }

  .module-loader .module-loader-group .module-loader-meta .module-loader-intro {
    flex-direction: column;
    width: 240px;
  }

  .module-loader
    .module-loader-group
    .module-loader-meta
    .module-loader-intro
    span:last-child {
    margin-bottom: 0;
  }
}`;

export const SAMPLE_TEMPLATE_IFRAME_ID = 'sample-template-iframe';

export const MODULE_INTERACTION_STYLES_ID = 'module-interaction-styles';
export const MODULE_INTERACTION_IFRAME_BODY_ID = 'pilotlaunchai-module-iframe';
export const MODULE_INTERACTION_ACTIVE_ATTRIBUTE = 'active';
export const MODULE_INTERACTION_HOVER_ATTRIBUTE = 'hovered';
export const MODULE_INTERACTION_DRAG_ATTRIBUTE = 'draggable';
export const MODULE_INTERACTION_HOVER_ID = 'pilotlaunchai-module-hover';
export const MODULE_INTERACTION_ACTIVE_ID = 'pilotlaunchai-module-active';
export const MODULE_INTERACTION_STYLES = `
  [active="true"] {
    position: relative;
  }
  [hovered="true"] {
    position: relative;
  }
  #${MODULE_INTERACTION_HOVER_ID} {
    border-color: ${variables.colorV2.contentModule.border.hover};
    border-style: solid;
    border-width: 0 3px 0 0;
    box-sizing: content-box;
    display: none;
    pointer-events: none;
    position: absolute;
    z-index: 2000000;
  }
  #${MODULE_INTERACTION_HOVER_ID}::after {
    border-color: transparent ${variables.colorV2.contentModule.border.hover} transparent transparent;
    border-style: solid;
    border-width: 10px;
    content: "";
    position: absolute;
    right: -1px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2000000;
  }
  #${MODULE_INTERACTION_ACTIVE_ID} {
    border-color: ${variables.colorV2.contentModule.border.active};
    border-style: solid;
    border-width: 0 3px 0 0;
    box-sizing: content-box;
    display: none;
    pointer-events: none;
    position: absolute;
    z-index: 2000000;
  }
  #${MODULE_INTERACTION_ACTIVE_ID}::after {
    border-color: transparent ${variables.colorV2.contentModule.border.active} transparent transparent;
    border-style: solid;
    border-width: 10px;
    content: "";
    left: initial;
    position: absolute;
    right: -1px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2000000;
  }
`;

export const ROUNDED_CORNER_HEIGHT = 20; //px
